import { get, patch } from '@/utils/https';

export const fetchCurrentUser = (teamId) => {
  const params = teamId ? { team_id: teamId } : undefined;
  return get('/api/app/v1/auth/me', params);
};
export const freelancersDetail = () => {
  return get('/api/app/v1/freelancers/me');
};
export const updateProfile = (params) => {
  return patch('/api/app/v1/auth/profile', params);
};

/** @param {'fr'|'en'} locale */
export const patchPreferredLocale = (locale) => {
  return patch('/api/app/v1/auth/profile', { preferred_locale: locale });
};

export default {
  fetchCurrentUser,
  freelancersDetail,
  updateProfile
};
